import { Association } from 'src/shared/models/association/association';
import { District } from 'src/shared/models/district/district';
import { InvoiceGroup } from 'src/shared/models/invoiceGroup/invoiceGroup';

// Max antal tecken i kommentaren, samma som kolumnen sys_users.comment (nvarchar(100)) i databasen.
export const USER_COMMENT_MAX_LENGTH = 100;

/* eslint-disable camelcase */
export interface UserRequest {
  firstName: string;
  lastName: string;
  email: string;
  comment?: string;
  personalIdentityNumber?: string;
  emailLoginEnabled?: boolean;
  bankIdLoginEnabled?: boolean;
  districts?: District[];
  associations?: Association[];
  invoiceGroups?: InvoiceGroup[];
  sysProducts: UserRequestSysProduct[];
}

export interface UserRequestSysProduct {
  product_id: number;
  authority?: number;
  isChecked?: boolean;
  yvName?: string;
}
